module.exports = __webpack_public_path__ + "static/media/picon3.226a3adc.png";